export default __webpack_public_path__ + "static/media/RESULT12.edf39f34.png";